package ru.villawonka.app.domain.model

enum class PostTypeDomain {
    ACCOMMODATION,
    TRANSPORT,
    MONEY_EXCHANGE,
    VISA_AGENCY
}

